import { css } from "../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      maxWidth: "712px",
      margin: "0 auto",
      "& h2": {
        marginBottom: "baseUnit.mobile2",
      },
      "& ul": {
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        rowGap: "baseUnit.mobile2",
        "& li": {
          marginBottom: "0",
        },
      },
    }),
  ctaWrapper: () =>
    css({
      display: "flex",
      justifyContent: "center",
      marginTop: "baseUnit.mobile3",
    }),
};
